import { render, staticRenderFns } from "./sendTransferForm.vue?vue&type=template&id=fc4f4ab2&"
import script from "./sendTransferForm.vue?vue&type=script&lang=js&"
export * from "./sendTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports